export default __webpack_public_path__ + "static/media/step_G_1_UA.f9765f02.png";